import React from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

export default class RightCol extends React.Component {
  //set constructor, super and state
  constructor() {
    super();
    this.state = {
      list: [],
      err: null
    };
  }

  //set componentDidMount
  componentDidMount() {
    this.fetchData();
  }

  buildList = data => {
    this.setState({ list: data });
  };

  //call JSON file
  fetchData = () => {
    axios
      .get('./data.json')
      .then(res => this.buildList(res.data))
      .catch(err => console.log(err));
  };

  render() {
    return (
      <div className="product-grid">
        {this.state.list.length > 0 &&
          this.state.list.map(item => (
            <div className="col-4-of-12">
              <Link
                to={{
                  pathname: `/electric-guitars/${item.link}`,
                  state: {
                    item: item
                  }
                }}
                className={`product-tile__link ${item.class}`}
              >
                <div className="product-tile">
                  <div className="product-tile__img-container">
                    <img
                      src={item.image}
                      alt=""
                      className="product-tile__img"
                    />
                  </div>
                  <div className="product-tile__body">
                    <h3 className="product-tile__name">{item.model}</h3>
                    <div className="product-tile__price">{item.price}</div>
                  </div>
                </div>
              </Link>
            </div>
          ))}
      </div>
    );
  }
}
